"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SiteCode_exports = {};
__export(SiteCode_exports, {
  default: () => SiteCode_default
});
module.exports = __toCommonJS(SiteCode_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18 5.25C18.2344 5.25 18.4297 5.33464 18.5859 5.50391C18.7552 5.66016 18.8398 5.85547 18.8398 6.08984V14.4102C18.8398 14.6445 18.7552 14.8464 18.5859 15.0156C18.4297 15.1719 18.2344 15.25 18 15.25H3C2.76562 15.25 2.5638 15.1719 2.39453 15.0156C2.23828 14.8464 2.16016 14.6445 2.16016 14.4102V6.08984C2.16016 5.85547 2.23828 5.66016 2.39453 5.50391C2.5638 5.33464 2.76562 5.25 3 5.25H18ZM18 6.08984H3V14.4102H18V6.08984ZM6.75 7.75C6.85417 7.75 6.94531 7.78255 7.02344 7.84766C7.10156 7.91276 7.14714 7.99089 7.16016 8.08203V8.16016V12.3398C7.16016 12.457 7.12109 12.5547 7.04297 12.6328C6.96484 12.7109 6.86719 12.75 6.75 12.75C6.64583 12.75 6.55469 12.7174 6.47656 12.6523C6.39844 12.5872 6.35286 12.5091 6.33984 12.418V12.3398V8.58984H5.91016C5.80599 8.58984 5.71484 8.55729 5.63672 8.49219C5.57161 8.42708 5.52604 8.34245 5.5 8.23828V8.16016C5.5 8.05599 5.53255 7.97135 5.59766 7.90625C5.66276 7.82812 5.74089 7.77604 5.83203 7.75H5.91016H6.75ZM9.66016 7.75C10.1289 7.75 10.526 7.89323 10.8516 8.17969C11.1771 8.45312 11.3398 8.77865 11.3398 9.15625L11.3203 9.21484L11.3398 9.25391C11.3398 9.55339 11.1966 9.91146 10.9102 10.3281C10.6237 10.7318 10.194 11.2135 9.62109 11.7734L9.48438 11.9102H10.9102C11.0143 11.9102 11.1055 11.9427 11.1836 12.0078C11.2617 12.0729 11.3073 12.1576 11.3203 12.2617V12.3398C11.3203 12.444 11.2878 12.5352 11.2227 12.6133C11.1576 12.6784 11.0794 12.724 10.9883 12.75H10.9102H8.41016C8.22786 12.75 8.09766 12.6654 8.01953 12.4961C7.95443 12.3138 7.99349 12.1576 8.13672 12.0273L8.48828 11.6953L8.82031 11.3828L9.11328 11.1094L9.38672 10.8359L9.62109 10.582L9.83594 10.3281L10.0117 10.1133L10.168 9.91797C10.2721 9.77474 10.3503 9.65104 10.4023 9.54688C10.4674 9.44271 10.5 9.35807 10.5 9.29297V9.15625C10.513 9.03906 10.4414 8.91536 10.2852 8.78516C10.1289 8.65495 9.92057 8.58984 9.66016 8.58984C9.3737 8.58984 9.16536 8.64193 9.03516 8.74609C8.90495 8.85026 8.83984 9.00651 8.83984 9.21484C8.83984 9.33203 8.79427 9.42969 8.70312 9.50781C8.625 9.58594 8.52734 9.625 8.41016 9.625C8.29297 9.625 8.19531 9.58594 8.11719 9.50781C8.03906 9.41667 8 9.31901 8 9.21484C8 8.75911 8.14974 8.40104 8.44922 8.14062C8.76172 7.88021 9.16536 7.75 9.66016 7.75ZM13.8398 7.75C14.3346 7.75 14.7318 7.88021 15.0312 8.14062C15.3438 8.40104 15.5 8.7526 15.5 9.19531C15.5 9.42969 15.4609 9.63151 15.3828 9.80078C15.3047 9.97005 15.1875 10.1198 15.0312 10.25L15.1094 10.3281C15.2135 10.4323 15.2982 10.556 15.3633 10.6992C15.4284 10.8424 15.474 10.9987 15.5 11.168V11.3047C15.5 11.7604 15.3372 12.1185 15.0117 12.3789C14.6992 12.6393 14.3086 12.763 13.8398 12.75C13.3711 12.75 12.974 12.6068 12.6484 12.3203C12.3229 12.0339 12.1602 11.6953 12.1602 11.3047C12.1602 11.1875 12.1992 11.0898 12.2773 11.0117C12.3685 10.9206 12.4727 10.875 12.5898 10.875C12.694 10.875 12.7786 10.9076 12.8438 10.9727C12.9219 11.0378 12.974 11.1224 13 11.2266V11.3047C13 11.4609 13.0781 11.6042 13.2344 11.7344C13.3906 11.8516 13.5924 11.9102 13.8398 11.9102C14.1003 11.9232 14.3021 11.8776 14.4453 11.7734C14.5885 11.6562 14.6602 11.5 14.6602 11.3047C14.6602 11.1224 14.5951 10.9792 14.4648 10.875C14.3346 10.7708 14.1068 10.6992 13.7812 10.6602C13.5469 10.6341 13.4297 10.4974 13.4297 10.25C13.4297 10.0026 13.5534 9.86589 13.8008 9.83984C14.1133 9.80078 14.3346 9.73568 14.4648 9.64453C14.5951 9.54036 14.6602 9.39714 14.6602 9.21484C14.6602 9.00651 14.5885 8.85026 14.4453 8.74609C14.3151 8.64193 14.1133 8.58984 13.8398 8.58984C13.5794 8.58984 13.3711 8.65495 13.2148 8.78516C13.0716 8.90234 13 9.04557 13 9.21484C13 9.31901 12.9609 9.41667 12.8828 9.50781C12.8047 9.58594 12.707 9.625 12.5898 9.625C12.4727 9.625 12.3685 9.58594 12.2773 9.50781C12.1992 9.41667 12.1602 9.31901 12.1602 9.21484C12.1602 8.79818 12.3229 8.45312 12.6484 8.17969C12.974 7.89323 13.3711 7.75 13.8398 7.75Z",
      fill: "currentColor"
    }
  )
);
const SvgSiteCode = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var SiteCode_default = SvgSiteCode;
